var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


//////////////////
// WEBPACK FOOTER
// /Volumes/Data HD/Git-UI/uikit-fullscreen/~/babel-polyfill/~/core-js/modules/_has.js
// module id = 10
// module chunks = 0